/**
 * Index de recherche côté client (MiniSearch) : plein texte, insensible aux
 * accents, tolérant aux fautes légères, < 200 ms pour 1 000 livres (RG-21, RG-12).
 */
import MiniSearch from 'minisearch'
import { normalize } from '@/services/format'

export interface Searchable {
  id: string
  title: string
  authors: string[]
  personalNotes?: string
}

const processTerm = (term: string): string | null => {
  const t = normalize(term)
  return t.length > 0 ? t : null
}

export type SearchField = 'title' | 'authors' | 'personalNotes'

export function buildIndex<T extends Searchable>(items: T[], fields: SearchField[]): MiniSearch<T> {
  const index = new MiniSearch<T>({
    fields,
    storeFields: [],
    extractField: (doc, field) => {
      const value = (doc as unknown as Record<string, unknown>)[field]
      if (Array.isArray(value)) return value.join(' ')
      return typeof value === 'string' ? value : ''
    },
    processTerm,
    searchOptions: {
      processTerm,
      prefix: true,
      fuzzy: (term) => (term.length > 3 ? 0.2 : false),
      boost: { title: 2, authors: 1.5 },
      combineWith: 'AND',
    },
  })
  index.addAll(items)
  return index
}

/** Identifiants des documents correspondant à la requête, par pertinence. */
export function searchIds<T extends Searchable>(index: MiniSearch<T>, q: string): string[] {
  const query = q.trim()
  if (query === '') return []
  return index.search(query).map((r) => String(r.id))
}
